import { ParagraphProgressDto } from './paragraph-progress.model';
import { ParagraphProgress } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapParagraphProgress(
  paragraphProgressDto: ParagraphProgressDto,
): ParagraphProgress {
  return {
    id: paragraphProgressDto.id,
    bookId: paragraphProgressDto.bookId,
    chapterId: paragraphProgressDto.chapterId,
    paragraphId: paragraphProgressDto.paragraphId,
    readTheory: paragraphProgressDto.readTheory,
    seenVideos: paragraphProgressDto.seenVideos,
    examinationMaxScore: paragraphProgressDto.examinationMaxScore,
    completed: paragraphProgressDto.completed,
  };
}
